import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageLayoutComponent } from './_shared/component/page-layout/page-layout.component';


const routes: Routes = [{
  path: '',
  component: PageLayoutComponent,
  children: [{
    path: '',
    loadChildren: () => import('./_module/website/website.module').then(m => m.WebsiteModule)
  }]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
